module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_12_4.b473c01e.jpeg";